import {
  PROGRAMS_SUCCESS,
  PROGRAMS_ERROR,
  PROGRAMS_REQUEST
} from '../constants/ActionTypes';

const companyPrograms = (
  state = {
    percentResponded: null,
    providedComment: null,
    providedAreaOfImprovement: null,
    providedAreaOfExcellence: undefined,
    providedReward: null,
    answeredAdditionalQuestion: null,
    commentedAdditionalQuestion: null,

    twitterShareInitiated: null,
    twitterFollowInitiated: null,
    facebookShareInitiated: null,
    facebookFollowInitiated: null,
    customLinkInitiated: null,
    percentEligibleSharesInitiated: null,

    perSurveyQuestion: [],
    perSurveyQuestionIdentifier: [],

    totalCount: null,
    doNotSend: null,
    unsubscribed: null,
    emailSuppressed: null,
    rejected: null,
    bounced: null,
    delivered: null,

    deliverabilityOverTime: { datasets: [] },

    error: false,
    isLoading: false,
  },
  action
) => {
  switch (action.type) {
    case PROGRAMS_REQUEST: {
      return Object.assign({}, state, { isLoading: true, error: false });
    }
    case PROGRAMS_ERROR: {
      return Object.assign({}, state, { isLoading: false, error: true });
    }
    case PROGRAMS_SUCCESS: {
      const { availableFilters, ...other } = action.programs;
      return Object.assign({}, state, other, {
        isLoading: false,
        error: false,
      });
    }
    default: {
      return state;
    }
  }
};

export default companyPrograms;
